import api from "../../../services/api";

const APIS = {
  CUSTOMER_DASHBOARD_DATA: "/CustomerDashBoard/customer-dashboard",
};

export const getCustomerDashboardData = async (payload = {}) => {
  try {
    const response = await api.post(APIS.CUSTOMER_DASHBOARD_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching Customer Dashboard data:", error);
    throw error;
  }
};